export interface AdminBreadcrumbSegment {
  label: string;
  /** Segment cliquable (ex. retour à l’accueil admin). Le dernier segment est toujours la page courante. */
  onActivate?: () => void;
}

interface AdminBreadcrumbProps {
  segments: AdminBreadcrumbSegment[];
}

export default function AdminBreadcrumb({ segments }: AdminBreadcrumbProps) {
  if (!segments.length) {
    return null;
  }

  const lastIndex = segments.length - 1;

  return (
    <nav aria-label="Fil d'Ariane" className="text-sm">
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        {segments.map((segment, index) => {
          const isCurrent = index === lastIndex;

          return (
            <li key={`${segment.label}-${index}`} className="flex items-center gap-x-1.5">
              {index > 0 ? (
                <span className="select-none text-on-surface-variant/45" aria-hidden>
                  /
                </span>
              ) : null}
              {isCurrent ? (
                <span className="font-semibold text-on-surface">{segment.label}</span>
              ) : segment.onActivate ? (
                <button
                  type="button"
                  onClick={segment.onActivate}
                  className="font-medium text-on-surface-variant transition-colors hover:text-primary"
                >
                  {segment.label}
                </button>
              ) : (
                <span className="font-medium text-on-surface-variant">{segment.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
